import { render, staticRenderFns } from "./TransportCostsReport.vue?vue&type=template&id=4d6c2a1a&scoped=true&"
import script from "./TransportCostsReport.vue?vue&type=script&lang=ts&"
export * from "./TransportCostsReport.vue?vue&type=script&lang=ts&"
import style0 from "./TransportCostsReport.vue?vue&type=style&index=0&id=4d6c2a1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6c2a1a",
  null
  
)

export default component.exports